<template>
    <form-row title="Have you sent the original documents to the title company?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_sent_to_title_company"
                v-model="has_sent_to_title_company"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_sent_to_title_company"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Sent:"
                :value="attorney.sent_to_title_company_at"
                name="sent_to_title_company_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_sent_to_title_company: this.attorney.has_sent_to_title_company,
        }
    },
}
</script>
